import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';
import PropTypes from 'prop-types';

const Spinner = (props) => {
  return (
    <div className="spinner" style={styles.spinner}>
      <BeatLoader color={props.color ?? '#ff1706'} />
    </div>
  );
};

Spinner.propTypes = {
  color: PropTypes.string,
};

export default Spinner;

const styles = {
  spinner: {
    textAlign: 'center',
    padding: '2rem 0',
  },
};
